import {createStrokeSVG} from './TEMPLATE'

// tabler: trash
export const Trash_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M4 7l16 0',
    'M10 11l0 6',
    'M14 11l0 6',
    'M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12',
    'M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: trash
export const Trash_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M4 7l16 0',
    'M10 11l0 6',
    'M14 11l0 6',
    'M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12',
    'M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
